import { useState } from "react";
import { useDispatch } from "react-redux";
import { updateCartDetails } from "../../../redux/reducers/index";
import { addToCart } from "../../../utils/helper";
import { getProductStatus } from "../../../utils/helper";
import { toastMsg } from "@tw/shared-ui-components/lib/components/toastMessage/toastMessage";

const useAddToCart = () => {
  const dispatch = useDispatch();
  const [details, setDetails] = useState({});
  const [showModal, setShowModal] = useState(false);

  const addToCartStatus = async (product) => {
    let productStatusObj = getProductStatus(product?.productStatus);
    console.log(product.productStatus);
    try {
      if (
        product?.productStatus === "outOfStock" ||
        product?.productStatus === "notForSale" ||
        product?.productStatus === "upcoming"
      ) {
        setDetails({
          ...product,
          productStatusLabel: productStatusObj?.label,
          msg: "This product is out of stock. It will be on sale on Jan 1st 2022! ",
        });
        console.log(details);
        setShowModal(true);
        return;
      }

      const res = await addToCart(product.itemCode, 1);
      if (res.status === 200) {
        dispatch(
          updateCartDetails({
            id: "singleProduct",
            installment: res?.data?.data?.productList?.[0]?.saleAttributes?.find(
              (attribute) => attribute?.key === "multi_dimension_payment"
            )?.value,
            totalQuantity: res?.data?.data?.totalQuantity,
            products: [{ product, quantity: 1 }],
          })
        );
      } else {
        toastMsg(res?.response?.data?.message);
      }
    } catch (err) {
      toastMsg(err?.response?.data?.message);
      console.error(err);
    }
  };
  return {
    details,
    setShowModal,
    showModal,
    addToCartStatus,
  };
};

export default useAddToCart;
